<template>
    <b-card title="Export Addon Survey">
        <b-form-group label="Main Survey">
            <b-form-select v-model="survey_id" :options="options"/>
        </b-form-group>
        <b-button v-show="survey_id" @click.prevent="export_excel">Download Excel</b-button>
    </b-card>    
</template>
<script>
export default {
    name : 'AddonSurveyExport',
    created() {
        this.surveys_get();
    },
    data() {
        return {
            survey_id: null,
            options: [],
        }
    },
    methods: {
        surveys_get() {
            this.$store.dispatch(
                'records_readlist',
                {
                    table_name: 'g_surveys',
                    filter: {
                        addon_survey: {
                            operator: '>',
                            value: 0,
                            realfield: true
                        },
                        user_id: {
                            operator: '>',
                            value: 0,
                            realfield: true,
                        }
                    }
                }
            )
            .then((resp) => {
                const options = resp.data.result.map((r) => {
                    return {
                        value: r.id,
                        text: `${r.survey_name} (${r.id})`,
                    }
                });
                this.options = options;
            })
        },
        export_excel() {
            this.$store.dispatch('gdq_addonsurvey_exportexcel', { survey_id: this.survey_id})
            .then((resp) => {
                var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                var filename = `AddonSurvey_${this.survey_id}`;
                fileLink.setAttribute("download", filename + ".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();
            });
        },
    }
}
</script>
<style scoped>
</style>
